import React, { useEffect, useState } from 'react';

import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import { Button } from 'shared/components/atoms/Button/Button';
import { Modal } from 'shared/components/organisms/Modal/Modal';

import mail from 'assets/icons/mail.svg';
import filled_mail from 'assets/icons/filled_mail.svg';
import locker from 'assets/icons/locker.svg';
import filled_locker from 'assets/icons/filled_locker.svg';

import { Container, ReadPolicy, Terms } from './_thirdRegisterGroup';
import { emailValidation } from 'utils/format';
import api from 'services/api';
import { toast } from 'react-toastify';

interface RegisterProps {
  email: string;
  setEmail: Function;
  password: string;
  setPassword: Function;
  passwordConfirmation: string;
  setPasswordConfirmation: Function;
  agreedToPolicy: boolean;
  setAgreedToPolicy: Function;
  showTerms: boolean;
  setShowTerms: Function;
  handleCreateUser: Function;
  setCurrentStep: Function;
}

export const ThirdRegisterGroup: React.FC<RegisterProps> = ({
  email,
  setEmail,
  password,
  setPassword,
  passwordConfirmation,
  setPasswordConfirmation,
  agreedToPolicy,
  setAgreedToPolicy,
  showTerms,
  setShowTerms,
  handleCreateUser,
  setCurrentStep,
}) => {
  const [termsData, setTermsData] = useState('')

  const disableCondition = () => {
    if (
      emailValidation(email) === false ||
      password.length < 8 ||
      password !== passwordConfirmation ||
      !agreedToPolicy
    ) {
      return true;
    }

    return false;
  };

  const ensureTerms = async () => {
    try {
      const response: any = await api.get('/system-infos')

      setTermsData(response?.data?.system_infos?.terms_and_conditions);
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    ensureTerms()
  },[])

  return (
    <Container className="group-wrapper">
      <IconInput
        icon={mail}
        activeIcon={filled_mail}
        placeholder={'E-mail'}
        inputValue={email}
        setInputValue={setEmail}
        type={'e-mail'}
      />

      <IconInput
        icon={locker}
        activeIcon={filled_locker}
        placeholder={'Senha (mínimo 8 dígitos)'}
        inputValue={password}
        setInputValue={setPassword}
        type="password"
      />

      <IconInput
        icon={locker}
        activeIcon={filled_locker}
        placeholder={'Confirmar senha'}
        inputValue={passwordConfirmation}
        setInputValue={setPasswordConfirmation}
        type="password"
      />

      <ReadPolicy>
        <label className="policy__checkbox-label">
          <input
            type="checkbox"
            checked={agreedToPolicy}
            onChange={() => setAgreedToPolicy(!agreedToPolicy)}
          />

          <span>&#10003;</span>

          <b className="policy__checkbox-label_text">
            Li e aceito os termos de uso
          </b>
        </label>

        <div
          className="policy__read-terms"
          onClick={() => setShowTerms(!showTerms)}
        >
          Ler termos.
        </div>
      </ReadPolicy>

      <Button onClick={() => handleCreateUser()} disabled={disableCondition()}>
        Próximo
      </Button>

      <Button backgroundColor='#C42D2D' onClick={() => setCurrentStep(1)}>
        Voltar
      </Button>

      <Modal showModal={showTerms} setShowModal={setShowTerms}>
        <Terms>
          <div className="terms__title">Termos de uso e condições</div>
          <div className="terms__content">
            {termsData}
            <ReadPolicy className="modal">
              <label className="policy__checkbox-label">
                <input
                  type="checkbox"
                  checked={agreedToPolicy}
                  onChange={() => setAgreedToPolicy(!agreedToPolicy)}
                />

                <span>&#10003;</span>

                <b className="modal__policy__checkbox-label_text">
                  Li e aceito concordo com os termos de uso
                </b>
              </label>
            </ReadPolicy>
          </div>
        </Terms>
      </Modal>
    </Container>
  );
};
